import React from 'react';
import useProductName from 'brand-customization/useProductName';

import { Button, Panel } from 'components/bootstrap';

type Props = {
  eventKey: string;
  onStepComplete: () => void;
};

const InstallForwarderStep = ({ eventKey, onStepComplete }: Props) => {
  const productName = useProductName();

  return (
    <Panel eventKey={eventKey}>
      <Panel.Heading>
        <Panel.Title>
          <Panel.Toggle tabIndex={0}>1. Install Forwarder</Panel.Toggle>
        </Panel.Title>
      </Panel.Heading>
      <Panel.Body collapsible>
        <p>
          First download and install{' '}
          <a href="https://www.graylog.org/downloads/" target="_blank" rel="noopener noreferrer">
            {productName} Forwarder
          </a>{' '}
          in your infrastructure.
        </p>
        <Button bsStyle="primary" bsSize="small" onClick={onStepComplete}>
          Continue
        </Button>
      </Panel.Body>
    </Panel>
  );
};

export default InstallForwarderStep;
